import {createSlice} from '@reduxjs/toolkit';

interface EmailInitialState {
  tableLoading: boolean;
}

const initialState: EmailInitialState = {
  tableLoading: false,
};

const emailSlice = createSlice({
  name: 'email',
  initialState: initialState,
  reducers: {
    setEmailsTableLoading: (state, action) => {
      state.tableLoading = action.payload;
    },
  },
});

export const {setEmailsTableLoading} = emailSlice.actions;
export default emailSlice.reducer;
